import { useTranslation } from 'react-i18next'
import { Button, Modal, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'

import { Card } from '@/ui'
import { useRouter } from '@/hooks/router'

import { useUserStore } from '@/stores/app/user'
import { urls } from '@/utils/constants'

const useStyles = makeStyles((theme: Theme) => ({
    modal: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },

    title: {
        color: theme.palette.secondary.main,
        marginBottom: '2vh',
    },

    button: {
        marginTop: '5vh',
    },
}))

export const AskCreditCard = () => {
    const classes = useStyles()
    const router = useRouter()
    const { t } = useTranslation()

    const isAskingAddCreditCard = useUserStore(
        (state) => state.isAskingAddCreditCard,
    )

    const updateIsAskingAddCreditCard = useUserStore(
        (state) => state.updateIsAskingAddCreditCard,
    )

    return (
        <Modal
            className={classes.modal}
            open={isAskingAddCreditCard}
            onClose={() => {
                updateIsAskingAddCreditCard(false)
            }}
        >
            <Card>
                {/* Title */}
                <Typography
                    className={classes.title}
                    variant='h1'
                >
                    {t('creditCard')}
                </Typography>

                {/* Message */}
                <div>{t('needsCreditCard')}</div>

                {/* Add button */}
                <Button
                    className={classes.button}
                    variant='contained'
                    onClick={() => {
                        updateIsAskingAddCreditCard(false)
                        router.push(urls.ACCOUNT)
                    }}
                >
                    {t('add')}
                </Button>
            </Card>
        </Modal>
    )
}
